module.exports = "/_next/static/images/ie-636f016d168626568d1bc881597dcbcb.svg";